export const INIT_STATE = 'INIT_STATE';
export const SET_PROFILE_DATA = 'SET_PROFILE_DATA';
export const SET_SETTINGS_OPTIONS = 'SET_SETTINGS_OPTIONS';
export const SET_PLANTS_DATA = 'SET_PLANTS_DATA';
export const SET_SELECTED_PLANT = 'SET_SELECTED_PLANT';
export const SET_SIGNED_IN_USER = 'SET_SIGNED_IN_USER';
export const SET_ALARMS = 'SET_ALARMS';
export const SET_SIMULATIONS = 'SET_SIMULATIONS';
